export const SOLANA_CONNECT_WALLET = 'SOLANA_CONNECT_WALLET';
export const SOLANA_DISCONNECT_WALLET = 'SOLANA_DISCONNECT_WALLET';
export const SOLANA_SET_WALLET_ADDRESS = 'SOLANA_SET_WALLET_ADDRESS';
export const SOLANA_LOGOUT = 'SOLANA_LOGOUT';